import { useState, useCallback } from 'react';

export const useCopyGroupHirerarchyModal = () => {

  const [showModel, setShowModel] = useState<boolean>(false);
  const [groupHierarchy, setGroupHierarchy] = useState<string>("");
  const [copied, setCopied] = useState<boolean>(false);

  const handleClose = useCallback(() => {
    setShowModel(false);
  }, []);

  const handleShow = useCallback(() => {
    setShowModel(true);
  }, []);

  return {
    showModel,
    copied,
    setCopied,
    handleShow,
    handleClose,
    groupHierarchy,
    setGroupHierarchy,
  };
};
